import { scrollToElement, throttle } from "./Util";
import { scrollWords } from "./MainPage";

const $header = $(".js-header");
const $wrap = $(".wrap");
const $content = $(".content");

/* Скролл ко --му экрану */
$(".js-scroll-down").on("click", function (e) {
    scrollToElement($(".content"), true);

    e.preventDefault();
});

/* Вернуться вверх */
$(".js-scroll-top").on("click", function (e) {
    scrollToElement($("html"), true);

    e.preventDefault();
});

/* Открытие меню */
$(".js-menu-btn").on("click", function (e) {
    $(this).toggleClass("_open");
    $header.toggleClass("_menu-is-open");

    e.preventDefault();
});

/* Анимированные анкоры пуктов меню */
$(".js-header-menu-item").on("click", function (e) {
    const currAnchor = $(this).attr("href").replace("#", "");
    const $currWrap = $(`[data-anchor="${currAnchor}"]`);

    if (App.W.outerWidth() < 640) {
        $(".js-menu-btn").trigger("click");
    }

    scrollToElement($currWrap);
    e.preventDefault();
});

/* Мини-хедер при скролле */
App.W.on("scroll", throttle(showMiniHeader, 100));

function showMiniHeader() {
    const headerBottomPosition =
        0.9 * $header.outerHeight() - $(".header-menu__content").outerHeight();

    if (App.W.scrollTop() > headerBottomPosition) {
        $header.addClass("_showen-menu-line");
    } else {
        $header.removeClass("_showen-menu-line");
    }
}

$(".langswitcher a").on("click", function (e) {
    e.preventDefault();
    $(".langswitcher li").removeClass("active");
    $("html").attr("lang", $(this).data("lang"));
    $(this).parent().addClass("active");
    setDataLang();
});

function setDataLang() {
    $("body *[lang]").each(function(el) {
        if ($('html').attr('lang') === 'ru') {
            $(this).html($(this)[0].dataset.ru);
        }else {
            $(this).html($(this)[0].dataset.en);
        }
    });

    $("input").each(function(el) {
        if ($(this).is(":text") || $(this).is("[type=tel]")) {
            if ($("html").attr("lang") === "ru") {
                $(this).attr("placeholder", $(this)[0].dataset.ru);
            } else {
                $(this).attr("placeholder", $(this)[0].dataset.en);
            }
        }
    });

    $("input").each(function (el) {
        if ($(this).is(":submit")) {
            if ($("html").attr("lang") === "ru") {
                $(this).attr("value", $(this)[0].dataset.ru);
            } else {
                $(this).attr("value", $(this)[0].dataset.en);
            }
        }
    });

    $("textarea").each(function (el) {
        if ($("html").attr("lang") === "ru") {
            $(this).attr("placeholder", $(this)[0].dataset.ru);
        } else {
            $(this).attr("placeholder", $(this)[0].dataset.en);
        }
        
    });
}

// $(document).bind("mousewheel", function (e) {
//     var nt = $(document.body).scrollTop() - (e.deltaY * e.deltaFactor * 100);
//     e.preventDefault();
//     e.stopPropagation();
//     $(document.body).stop().animate(
//         {
//             scrollTop: nt,
//         },
//         1000,
//         "easeInOutCubic"
//     );
// });



// WEBPACK FOOTER //
// ./_src/js/Header.js